import instance from "../utils/network";

export enum AdVideoType {
  PUB = "PUB",
  TOURNAMENT = "TOURNAMENT",
}

export interface SolutionAdVideoResponse {
  id: number;
  type: AdVideoType;
  fileName: string;
  order: number;
}

export interface SolutionAdVideoLogStartRequest {
  fileName: string;
  pubId: number;
  pubName: string;
  tournamentId: number;
  playerCount: number;
}

export interface SolutionAdVideoLogStartResponse {
  logId: number;
}

export function getSolutionAdVideoList(
  type: AdVideoType,
): Promise<SolutionAdVideoResponse[]> {
  return instance.get(`/seller/solution-ad-video/list?type=${type}`);
}

export function startSolutionAdVideoLog(
  request: SolutionAdVideoLogStartRequest,
): Promise<SolutionAdVideoLogStartResponse> {
  return instance.post(`/seller/solution-ad-video/start`, request);
}

export function endSolutionAdVideoLog(
  id: number,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/solution-ad-video/end/${id}`);
}
